import { createContext as e } from "react";
import { EventResolver as t } from "./eventResolver.js";
const n = e(t);
export {
  n as EventResolverContext
};
//# sourceMappingURL=event.js.map
